import { defineMessages } from 'react-intl';

export const templateDetailsMessages = defineMessages({
  enterTitle: {
    defaultMessage: 'Enter a title',
    id: 'SkQcEJYf3b',
    description: 'Placeholder for the template name field in template details',
  },
  saveAndExit: {
    defaultMessage: 'Save & exit',
    id: '854CEhF3Gz',
    description: 'Save button label when exiting template details',
  },
  saveAndUse: {
    defaultMessage: 'Save & use',
    id: '9ndAo/z204',
    description: 'Save button label in the template details modal',
  },
  saving: {
    defaultMessage: 'Saving',
    id: '4MqIR2k8Q0',
    description: 'Save button label while a template save is in progress',
  },
  sharing: {
    defaultMessage: 'Sharing',
    id: 'CrVo8CUgNw',
    description: 'Settings menu item for template sharing options',
  },
  goToLibrary: {
    defaultMessage: 'Go to library',
    id: 'jCz+8hm4eO',
    description: 'Button to navigate back to the template library',
  },
  backToLibrary: {
    defaultMessage: 'Back to library',
    id: 'ea+TKSNtG7',
    description: 'Link to return to the template library from template details',
  },
  templateLibraryCrumb: {
    defaultMessage: 'Template library',
    id: '+xFznXmbov',
    description:
      'Breadcrumb link to the template library in the v2 template editor header',
  },
  structure: {
    defaultMessage: 'Structure',
    id: 'NLAK+HS05a',
    description: 'Label for the structure tab in template details',
  },
  example: {
    defaultMessage: 'Example',
    id: 'EPeimxl1Kj',
    description: 'Label for the example tab in template details',
  },
  structurePlaceholder: {
    defaultMessage:
      'Build your structure here, or draft your ideal note in the example tab to generate it automatically.',
    id: 'yZDyPYozMC',
    description: 'Placeholder in the structure editor',
  },
  examplePlaceholder: {
    defaultMessage:
      'Write or paste your ideal note. We’ll turn it into a reusable template in the structure tab.',
    id: 'uaNqf2sPNK',
    description: 'Placeholder in the example editor',
  },
  looksABitDifferentTitle: {
    defaultMessage: 'Try editing this example note',
    id: 'ux0mTmZdhL',
    description: 'Popover title on the example tab trigger',
  },
  looksABitDifferentDescription: {
    defaultMessage:
      'Any changes you make here will automatically update the template’s structure.',
    id: '4LUcJl5Uau',
    description: 'Popover body on the example tab when not from file upload',
  },
  looksABitDifferentDescriptionFileUpload: {
    defaultMessage:
      'This example is based on your upload and a transcript, it may vary from the original.',
    id: '1lE918UCvx',
    description: 'Popover body on the example tab when created from file upload',
  },
  type: {
    defaultMessage: 'Type',
    id: 'R6mlfbSG0E',
    description: 'Template type setting label',
  },
  primaryRecordOfEncounter: {
    defaultMessage: 'Primary record of the encounter',
    id: 'oUxn6z7oOk',
    description: 'Description for consult note template type',
  },
  supplementaryArtefacts: {
    defaultMessage: 'Supplementary artefacts',
    id: 'WHQNBW85LI',
    description: 'Description for document template type',
  },
  prechartDescription: {
    defaultMessage: 'Pre-visit summaries for upcoming appointments.',
    id: 'zYsi/i1/wZ',
    description: 'Description for prechart template type',
  },
  settings: {
    defaultMessage: 'Settings',
    id: '6YwkWnPAHu',
    description: 'Settings menu trigger label in template details header',
  },
  version: {
    defaultMessage: 'Version {number}',
    id: '0RBsfkAF1V',
    description: 'Version label in the version selector',
  },
  unsavedChangesWarning: {
    defaultMessage: 'You have unsaved changes. Are you sure you want to leave?',
    id: 'gjq1Q4ZJPA',
    description: 'Browser confirmation when leaving template details with unsaved edits',
  },
  helperButtonTooltip: {
    defaultMessage: 'Help',
    id: 'HzyJ2ALbRB',
    description: 'Tooltip for the syntax or example helper toggle button',
  },
  syntaxGuide: {
    defaultMessage: 'Structure syntax guide',
    id: 'Pw7bSOkk8q',
    description: 'Title of the structure syntax helper panel',
  },
  syntaxGuideCaption: {
    defaultMessage: 'Syntax is only required when editing in the structure tab',
    id: '18OpJ5W+R2',
    description: 'Caption under the structure syntax guide title',
  },
  sectionHeadings: {
    defaultMessage: 'Section headings',
    id: 'EYkdtEqGZl',
    description: 'Syntax guide section for section headings',
  },
  sectionHeadingsDescription: {
    defaultMessage: 'Structure your note sections in plain text',
    id: 'SniIvHmvIq',
    description: 'Syntax guide description for section headings',
  },
  sectionHeadingsExample: {
    defaultMessage: 'e.g. History of Presenting Illness',
    id: 'h7t9zp/bkx',
    description: 'Syntax guide example for section headings',
  },
  placeholders: {
    defaultMessage: 'Placeholders',
    id: 'HQzzeh9xvh',
    description: 'Syntax guide section for placeholders',
  },
  placeholdersDescription: {
    defaultMessage: 'Signal WHAT information to insert inside square brackets',
    id: 'GAGR1xPTh2',
    description: 'Syntax guide description for placeholders',
  },
  placeholdersExample: {
    defaultMessage: 'e.g. [Describe patient’s presenting complaint]',
    id: 'yol1/o5utW',
    description: 'Syntax guide example for placeholders',
  },
  verbatim: {
    defaultMessage: 'Verbatim',
    id: 'TebhsacGNI',
    description: 'Syntax guide section for verbatim text',
  },
  verbatimDescription: {
    defaultMessage:
      'Include any exact words you want included in the output using quotation marks',
    id: 'MBUAFHiQdx',
    description: 'Syntax guide description for verbatim text',
  },
  verbatimExample1: {
    defaultMessage: 'e.g. “This note has been generated with the help of AI”',
    id: 'Hgg0la0ki6',
    description: 'Syntax guide first verbatim example',
  },
  verbatimExample2: {
    defaultMessage: 'e.g. “Signed Dr Jane Doe, General Surgeon”',
    id: 'ktdkthAf47',
    description: 'Syntax guide second verbatim example',
  },
  instructions: {
    defaultMessage: 'Instructions',
    id: 'TtMwlZD6Or',
    description: 'Syntax guide section for instructions',
  },
  instructionsDescription: {
    defaultMessage:
      'Tell Heidi HOW to handle information that is mentioned, AND not mentioned in the transcript, inside round brackets',
    id: 'K5XU1aAKRK',
    description: 'Syntax guide description for instructions',
  },
  instructionsExample1: {
    defaultMessage: 'e.g. (Write in narrative paragraphs with full sentences)',
    id: 'mKpoyA7qOD',
    description: 'Syntax guide first instructions example',
  },
  instructionsExample2: {
    defaultMessage:
      'e.g. (Only include if explicitly mentioned in transcript, contextual notes or clinical note, else omit section entirely)',
    id: '3Az6wUTYKO',
    description: 'Syntax guide second instructions example',
  },
  editExampleHelperTitle: {
    defaultMessage: 'Edit the example note and Heidi will update your template for you',
    id: '2eHZq345xf',
    description: 'Title of the edit example helper panel',
  },
  editExampleHelperWhatIsThisExample: {
    defaultMessage: 'What is this example?',
    id: 'GcOdShwexe',
    description: 'Edit example helper section heading',
  },
  editExampleHelperWhatIsThisExampleDescription: {
    defaultMessage:
      'This example uses a mock transcript combined with your default voice, scribe and memory settings. The example is a demo of how your template will look in a real session.',
    id: '/mwKSlR8Hz',
    description: 'Edit example helper section body',
  },
  editExampleHelperWhyDoesntItMatch: {
    defaultMessage: 'Why doesn’t it match my example I uploaded?',
    id: 'vfifwpJLfs',
    description: 'Edit example helper section heading',
  },
  editExampleHelperWhyDoesntItMatchDescription: {
    defaultMessage:
      'Heidi uses your example document to create a template, then applies it to a new demo transcript so you can see it in action.',
    id: '/Cw+N4v2Mv',
    description: 'Edit example helper section body',
  },
  editExampleHelperWhatKindsOfEdits: {
    defaultMessage: 'What kinds of edits can I make?',
    id: 'nPus39uzH4',
    description: 'Edit example helper section heading',
  },
  editExampleHelperWhatKindsOfEditsDescription: {
    defaultMessage: 'You can edit anything in the example such as:',
    id: 'CpGVkb2gMG',
    description: 'Edit example helper intro before edit type list',
  },
  editExampleHelperSectionsAndHeadings: {
    defaultMessage: 'Sections & Headings',
    id: 'xc+43jjhGs',
    description: 'Edit example helper item title',
  },
  editExampleHelperSectionsAndHeadingsDescription: {
    defaultMessage:
      'Rename headings, reorder sections, group content differently, or add new sections to reflect your document flow.',
    id: '+LUnfYI7Lt',
    description: 'Edit example helper item description',
  },
  editExampleHelperFormatting: {
    defaultMessage: 'Formatting',
    id: 'QmfT50CZzR',
    description: 'Edit example helper item title',
  },
  editExampleHelperFormattingDescription: {
    defaultMessage:
      'Adjust spacing, bullet points, or emphasis to suit your preferred layout.',
    id: 'I46XLhspMo',
    description: 'Edit example helper item description',
  },
  editExampleHelperContent: {
    defaultMessage: 'Content',
    id: 'sBrQC28+Cc',
    description: 'Edit example helper item title',
  },
  editExampleHelperContentDescription: {
    defaultMessage: 'Rewrite any text so it sounds exactly how you would write it.',
    id: 'LIg2C/Cd0P',
    description: 'Edit example helper item description',
  },
  editExampleHelperTipTitle: {
    defaultMessage: 'Use version history to undo changes anytime',
    id: 'JRKrPeN+/6',
    description: 'Tip banner title in edit example helper',
  },
  editExampleHelperTipDescription: {
    defaultMessage: 'You can experiment freely without losing your work.',
    id: '/UygiHB84p',
    description: 'Tip banner body in edit example helper',
  },
  warningModalTitle: {
    defaultMessage: 'Do you want to keep your latest changes?',
    id: 'zkeP8p0eyW',
    description: 'Title when leaving template details with unsaved changes',
  },
  warningModalDescription: {
    defaultMessage:
      'You’ve made some updates to this template that haven’t been saved. Save them now so nothing gets lost.',
    id: 'k+XhQW2l8q',
    description: 'Body when leaving template details with unsaved changes',
  },
  warningModalDiscardChanges: {
    defaultMessage: 'Discard changes',
    id: '4RWEo3eozu',
    description: 'Destructive action to discard unsaved template edits',
  },
  warningModalSaveAndExit: {
    defaultMessage: 'Save & exit',
    id: 'dw59kje5wr',
    description: 'Action to save template and leave template details',
  },
  warningModalExitWithoutSaving: {
    defaultMessage: 'Exit without saving',
    id: 'vtTxtqRtmJ',
    description: 'Action to leave without saving template edits',
  },
  warningModalDeleteTemplate: {
    defaultMessage: 'Delete template',
    id: 'IApEhnsY2y',
    description: 'Action to delete template from warning modal',
  },
  warningModalEmptyTemplate: {
    defaultMessage: 'Your template is empty and cannot be saved',
    id: 'keJ6831w8G',
    description: 'Title when saving an empty template',
  },
  warningModalEmptyTemplateDescription: {
    defaultMessage:
      'Leaving now will discard your changes and restore the last saved version of this template. If you no longer need it, you can delete it instead.',
    id: '8UzGVMjaLg',
    description: 'Body when saving an empty template',
  },
  savingModalTitle: {
    defaultMessage: 'Updating your template...',
    id: 'C5yBK6moiB',
    description: 'Title while template save is processing',
  },
  savingModalStopSaving: {
    defaultMessage: 'Stop saving',
    id: 'zj3jQ+cRMr',
    description: 'Action to cancel an in-progress template save',
  },
  errorUnsupportedRequest: {
    defaultMessage: 'Sorry, Heidi can’t support this request',
    id: 'riKB6kDhIl',
    description: 'Toast when template chat request is not supported',
  },
  errorGeneratingStructureFromExample: {
    defaultMessage: 'Error generating structure from example',
    id: 'wpEw6Mnn/0',
    description: 'Toast title when structure generation from example fails',
  },
  errorCreatingVersionControl: {
    defaultMessage: 'Error creating version control from structure',
    id: 'k/YERL9OoP',
    description: 'Toast title when version control creation fails',
  },
  errorUnknown: {
    defaultMessage: 'An unknown error occurred',
    id: 'k0tBdZw3C6',
    description: 'Fallback error description in template details',
  },
  errorExampleGenerationTitle: {
    defaultMessage: 'Something went wrong while creating your content',
    id: 'q4iLUjSew3',
    description: 'Error state title on example generation failure',
  },
  errorExampleGenerationDescription: {
    defaultMessage: 'Let’s try that again - your work is safe',
    id: 'Rb2+igb33k',
    description: 'Error state body on example generation failure',
  },
  errorProblemSendingMessage: {
    defaultMessage: 'There was a problem sending your message',
    id: 'Wpad4zEJU7',
    description: 'Toast when template chat message fails to send',
  },
  errorGeneratingExample: {
    defaultMessage: 'Error generating example',
    id: 'WRktfSf9t4',
    description: 'Toast title when example generation fails in chat',
  },
  retry: {
    defaultMessage: 'Retry',
    id: 'tPKerxGx49',
    description: 'Retry action on template details error states and toasts',
  },
  editingTemplate: {
    defaultMessage: 'Editing template',
    id: '9KbQH/t4so',
    description: 'Header title in template details modal',
  },
  chatboxPlaceholder: {
    defaultMessage: 'What would you like to change?',
    id: '/YMosLtdzW',
    description: 'Placeholder in template details chat input',
  },
  chatboxUpdatingExample: {
    defaultMessage: 'Updating your example',
    id: 'EAd3MEaT4Z',
    description: 'Animated placeholder while example is updating via chat',
  },
  chatboxTemplateGenerating: {
    defaultMessage: 'Template is generating',
    id: 'oZ74oN/BAW',
    description: 'Tooltip when transcript picker is disabled during generation',
  },
  chatboxTemplateIsStillLoading: {
    defaultMessage: 'Template is still loading',
    id: 'oNp7AAMhNz',
    description: 'Tooltip when send is disabled while the template is still loading',
  },
  changeTranscript: {
    defaultMessage: 'Change transcript',
    id: 'pK04OeGLII',
    description: 'Button label to pick a different demo transcript',
  },
  untitledSession: {
    defaultMessage: 'Untitled Session',
    id: 'KOYRaMueOt',
    description: 'Fallback session name in transcript picker',
  },
  searchTranscripts: {
    defaultMessage: 'Search transcripts',
    id: 'fOmXY5mrQ0',
    description: 'Placeholder for filtering transcript sessions in the picker',
  },
  noTranscriptsFound: {
    defaultMessage: 'No transcripts found.',
    id: '9GnomEUbQp',
    description: 'Empty state when transcript search returns no sessions',
  },
  noRecordedTranscript: {
    defaultMessage: 'No recorded transcript',
    id: 'OiNwHJECPY',
    description:
      'Heading of the transcript picker group listing sessions that cannot be picked because they have no recording',
  },
  failedToUpdateTranscript: {
    defaultMessage: 'Failed to update transcript',
    id: 'WEUnhZWWMT',
    description: 'Toast title when changing the demo transcript fails',
  },
  problemBased: {
    defaultMessage: 'Problem Based',
    id: 'nz59PiOgdP',
    description: 'Toggle label for problem-based charting in template settings',
  },
  useSections: {
    defaultMessage: 'Separate sections',
    id: 'ba2g29yDSw',
    description:
      'Toggle to generate this template with sectional headings and sectional prompts',
  },
  useSectionsIntroTitle: {
    defaultMessage: 'Headings are now separate sections',
    id: 'X7db0ViX2D',
    description: 'Toast title shown the first time Separate sections is turned on',
  },
  useSectionsIntroDescription: {
    defaultMessage:
      'Each top-level heading is its own section in the note, so you can edit and copy them independently.',
    id: 'OtT4xXj1cu',
    description: 'Toast body shown the first time Separate sections is turned on',
  },
  useSectionsConvertFailedTitle: {
    defaultMessage: 'Could not convert template',
    id: 'cfcntH6X1P',
    description: 'Toast title when converting a template to or from sections fails',
  },
  useSectionsConvertFailedDescription: {
    defaultMessage: 'Your template was left unchanged. Try again.',
    id: 'z4rbn+ttr9',
    description: 'Toast body when converting a template to or from sections fails',
  },
  useSectionsConvertUnsafeTitle: {
    defaultMessage: 'Could not convert template safely',
    id: 'yuelYhR26J',
    description: 'Toast title when convert-to-sections changes too much content',
  },
  useSectionsConvertUnsafeDescription: {
    defaultMessage:
      'The converted headings would change too much of this template. It was left unchanged. You can retry.',
    id: 'gKP79Y2YXc',
    description: 'Toast body when convert-to-sections fails the content guard',
  },
  useSectionsConvertIncompleteTitle: {
    defaultMessage: 'Conversion did not finish',
    id: 'g3i2Zv429c',
    description:
      'Toast title when the conversion stream closed before the converted template fully arrived',
  },
  useSectionsConvertIncompleteDescription: {
    defaultMessage:
      'The connection closed before the converted template fully arrived. Your template was left unchanged. You can retry.',
    id: '8sTXSqiP9x',
    description:
      'Toast body when the conversion stream closed before the converted template fully arrived',
  },
  useSectionsRetryWhileGeneratingTitle: {
    defaultMessage: 'Template is still generating',
    id: 'NZvm4f+hbP',
    description:
      'Toast title when Retry on a failed sections conversion is pressed while the template is still generating',
  },
  useSectionsRetryWhileGeneratingDescription: {
    defaultMessage: 'Wait for the template to finish generating, then retry.',
    id: 'SEdWFm089d',
    description:
      'Toast body when Retry on a failed sections conversion is pressed while the template is still generating',
  },
  useSectionsConvertTimeoutTitle: {
    defaultMessage: 'Conversion timed out',
    id: '7DMak+fAo9',
    description: 'Toast title when the conversion stream timed out upstream',
  },
  useSectionsConvertTimeoutDescription: {
    defaultMessage:
      'The conversion took too long and was stopped. Your template was left unchanged. You can retry.',
    id: '01IJuyiNlO',
    description: 'Toast body when the conversion stream timed out upstream',
  },
  chatStructureUnderstandingRequest: {
    defaultMessage: 'Understanding your request',
    id: 'UVID8gbZmj',
    description: 'Loading placeholder while processing a structure chat request',
  },
  chatStructureThinkingItThrough: {
    defaultMessage: 'Thinking it through',
    id: 'N2cRAEj/I/',
    description: 'Loading placeholder while processing a structure chat request',
  },
  chatStructureApplyingChanges: {
    defaultMessage: 'Applying your changes',
    id: '475xAxphXQ',
    description: 'Loading placeholder while processing a structure chat request',
  },
  saveTemplateUpdatingTemplate: {
    defaultMessage: 'Updating your template',
    id: '3zHfjVhmRy',
    description: 'Loading placeholder while template is saving',
  },
  templateTypeNote: {
    defaultMessage: 'Note',
    id: 'm7fjp8NA39',
    description: 'Consult note template type label',
  },
  templateTypeDocument: {
    defaultMessage: 'Document',
    id: '/q4BqM9i68',
    description: 'Document template type label',
  },
  templateTypePrechart: {
    defaultMessage: 'Prechart',
    id: 'emzx2vzeHy',
    description: 'Prechart template type label',
  },
  share: {
    defaultMessage: 'Share',
    id: 'h326JsZ4xj',
    description: 'Share template button label',
  },
  save: {
    defaultMessage: 'Save',
    id: 'vXQKHDGrUk',
    description: 'Generic save button label',
  },
  copy: {
    defaultMessage: 'Copy',
    id: 'ZpXaBR4qqu',
    description: 'Copy version control content action',
  },
  copied: {
    defaultMessage: 'Copied',
    id: 'euiMqaMXEp',
    description: 'Label after version content was copied',
  },
  makeDefault: {
    defaultMessage: 'Make default',
    id: 'Sm6m4giWxx',
    description: 'Toggle to set template as default',
  },
  fillRequiredFields: {
    defaultMessage: 'Please fill in all required fields',
    id: 'GBG5I5fS0Z',
    description: 'Tooltip when save is disabled due to validation',
  },
  regulatoryComplianceTitle: {
    defaultMessage:
      'Your template could not be saved as it is not compliant with regulatory guidelines',
    id: 'CifNDurFUr',
    description: 'Title on regulatory compliance warning modal',
  },
  regulatoryComplianceDescription: {
    defaultMessage:
      'Regulatory requirements stipulate that you don’t include any instructions in your template that might produce generative diagnoses, management plans, or other medical referrals and calculators.',
    id: 'YPj9O9TwN+',
    description: 'Body on regulatory compliance warning modal',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'KcAo/0cYaE',
    description: 'Link to learn more about regulatory guidelines',
  },
  returnToEditor: {
    defaultMessage: 'Return to editor',
    id: 'R1HlwRHg0B',
    description: 'Dismiss regulatory warning and return to editing',
  },
  fixForMe: {
    defaultMessage: 'Fix for me',
    id: 'P4BBuLEffv',
    description: 'Action to auto-fix regulatory issues via chat',
  },
  visibilityPrivate: {
    defaultMessage: 'Private',
    id: 'ZmkNQY/+JD',
    description: 'Private visibility option title',
  },
  visibilityPrivateDescription: {
    defaultMessage: 'Only you can access',
    id: 'rtenOE0Z6j',
    description: 'Private visibility option description',
  },
  visibilityCannotChange: {
    defaultMessage: 'This template’s visibility cannot be changed',
    id: 'EdhpwFXuxd',
    description: 'Tooltip when visibility cannot be edited',
  },
  visibilityTeam: {
    defaultMessage: 'Team',
    id: 'cUVLhwZSB/',
    description: 'Team visibility option title',
  },
  visibilityTeamDescriptionSimple: {
    defaultMessage: 'Team can use, only you can edit',
    id: '5ldJtYNv3V',
    description: 'Team visibility option description',
  },
  visibilitySpecificTeams: {
    defaultMessage: 'Specific teams',
    id: 'ZV9X5db/T1',
    description: 'Specific teams visibility option title',
  },
  visibilitySpecificTeamsDescription: {
    defaultMessage:
      'Allow users of select teams in your organization to use this template',
    id: 'zLMOVFEdF0',
    description: 'Specific teams visibility option description',
  },
  visibilityOrganizationWide: {
    defaultMessage: 'Organisation-wide',
    id: 'UF3dBeAiOU',
    description: 'Organisation-wide visibility option title',
  },
  visibilityOrganizationWideDescription: {
    defaultMessage:
      'Allow all users in your organization across all teams to use this template',
    id: 'JIX4LFEhWW',
    description: 'Organisation-wide visibility option description',
  },
  visibilityPublic: {
    defaultMessage: 'Public',
    id: 'uoeYiQt+46',
    description: 'Community visibility option title',
  },
  visibilityPublicDescription: {
    defaultMessage: 'Submit to the template community',
    id: 'XAJ1OcrT/Q',
    description: 'Community visibility option description',
  },
  visibilityCannotPublish: {
    defaultMessage: 'This template cannot be published to the community',
    id: 'PiZwzx+fi3',
    description: 'Tooltip when community publish is disabled',
  },
  visibilitySaving: {
    defaultMessage: 'Saving...',
    id: 'Ekco2EIikQ',
    description: 'Visibility settings save button while saving',
  },
  visibilitySaveSettings: {
    defaultMessage: 'Save visibility settings',
    id: 'FfBsWrMyte',
    description: 'Visibility settings save button label',
  },
  visibilityOnlyTeamAdminCan: {
    defaultMessage: 'Only Team admins or Template Managers can share this template.',
    id: 'lvPKkY+LRl',
    description: 'Tooltip when non-admin cannot enable team sharing',
  },
  visibilityNeedTeamToEnable: {
    defaultMessage: 'You need to join a team to enable sharing.',
    id: 'Qfi4rYhMf1',
    description: 'Tooltip when user has no team for sharing',
  },
  visibilityAskTeamAdminUpgradePractice: {
    defaultMessage: 'Requires a Practice plan. Ask your team admin to upgrade.',
    id: 'f0xQPQbOpC',
    description: 'Tooltip to upgrade for organisation visibility',
  },
  visibilityRequiresPracticePlan: {
    defaultMessage: 'Requires a Practice plan.',
    id: '9zWkj/bYAg',
    description: 'Tooltip when practice plan is required',
  },
  visibilityCommunity: {
    defaultMessage: 'Community',
    id: 'B1C/cNDcnH',
    description: 'Community visibility label in sharing settings',
  },
  visibilityOnlyMe: {
    defaultMessage: 'Only me',
    id: 'L/ikfNPwpi',
    description: 'Only me visibility label in sharing settings',
  },
  visibilityTeamLabel: {
    defaultMessage: 'Team',
    id: 'o1RjkNxDZT',
    description: 'Team visibility label in sharing settings',
  },
  visibilityOrganization: {
    defaultMessage: 'Organisation',
    id: 'vNXb6DmPGE',
    description: 'Organisation visibility label in sharing settings',
  },
  selectedTeamsCount: {
    defaultMessage: '{count} teams',
    id: 'lK83ZAoHx4',
    description: 'Label showing how many teams are selected for template visibility',
  },
  versionControllerErrorTitle: {
    defaultMessage: 'Error',
    id: '3a/1dU+Te+',
    description: 'Toast title when version copy fails',
  },
  versionControllerFailedToCopy: {
    defaultMessage: 'Failed to copy',
    id: 'YLGnw1EgIZ',
    description: 'Toast description when version copy fails',
  },
  versionControllerCopyAsPlainText: {
    defaultMessage: 'Copy as plain text',
    id: 'ESy4So7R58',
    description: 'Menu item to copy version as plain text',
  },
  versionControllerCopyWithFormattingWithoutLists: {
    defaultMessage:
      '<normal>Copy with formatting</normal> <secondary>(without lists)</secondary>',
    id: 'm2fBxe3U6T',
    description: 'Menu item to copy version with formatting but without lists',
  },
  versionControllerCopyWithFormattingWithLists: {
    defaultMessage:
      '<normal>Copy with formatting</normal> <secondary>(with lists)</secondary>',
    id: 'Gj8kYql5he',
    description: 'Menu item to copy version with formatting and lists',
  },
  disableReasonNonAdminTeam: {
    defaultMessage:
      'You cannot edit team templates because you are not a team administrator',
    id: 'lTlpp4UFsx',
    description: 'Tooltip when non-admin tries to edit a team template',
  },
  disableReasonTeamAdminOtherTeam: {
    defaultMessage:
      'You cannot edit this team template because it belongs to another team',
    id: 'Mw0wDTkSkQ',
    description: 'Tooltip when team admin edits another team’s template',
  },
  disableReasonNonAdminOrganization: {
    defaultMessage:
      'You cannot edit organization templates because you are not a global administrator',
    id: '0I4fPHAgD5',
    description: 'Tooltip when non-admin tries to edit an organization template',
  },
  disableReasonCannotEditHeidi: {
    defaultMessage:
      'You cannot edit Heidi templates because you are not a team administrator',
    id: 'g+s+u2akzX',
    description: 'Tooltip when user cannot edit a Heidi template',
  },
  dictateAnywhereHint: {
    defaultMessage: 'Press {shortcut} to dictate anywhere',
    id: 'qEKELlL+fn',
    description:
      "Hint under the template editor prompt teaching the user's configured Dictate shortcut",
  },
});

export const templateEditorDisableReasonMessages = {
  nonAdminEditingTeamTemplate: templateDetailsMessages.disableReasonNonAdminTeam,
  teamAdminEditingOtherTeamsTemplate:
    templateDetailsMessages.disableReasonTeamAdminOtherTeam,
  nonAdminEditingOrganizationTemplate:
    templateDetailsMessages.disableReasonNonAdminOrganization,
  cannotEditHeidiTemplate: templateDetailsMessages.disableReasonCannotEditHeidi,
} as const;
